import { ReactNode } from "react";

import { cn } from "@/lib/utils";

// 로그인 없는 고객 화면(/s·/c)의 바탕. centered 면 안내 카드를 화면 가운데에 둔다.
interface Props {
  children: ReactNode;
  centered?: boolean;
  className?: string;
  // 위 여백에 상태바 높이를 더한다 — className(p-0 로 머리를 직접 그리는 화면)·centered·바깥이 맡는 화면(데모 띠)은 끈다.
  safeTop?: boolean;
}

// 상태바 높이는 safeTop 일 때만 위 여백에 더한다 · 상태바 자리는 늘 바탕색으로 덮는다(safe-top-fill).
const CustomerScreenShell = ({ children, centered, className, safeTop = !className && !centered }: Props) => (
  <main
    className={cn(
      "safe-top-fill min-h-screen bg-background px-4 text-foreground",
      safeTop ? "pb-8 pt-safe-8" : "py-8",
      centered && "flex items-center justify-center",
      className
    )}>
    {children}
  </main>
);

export default CustomerScreenShell;
